import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from './api'


const initialState = {
  ...baseModelState,
}


export const cardRequest = createSlice({
  name: 'cardRequest',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateCardRequest);
  },
});

export default cardRequest.reducer;

export const CardRequestActions = cardRequest.actions;
